import React from 'react';
import Select, { components } from 'react-select';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { getFormRules, getDefaultValueInSelect } from 'helpers';
const { ValueContainer, Placeholder } = components;

const CustomValueContainer = ({ children, ...props }) => {
    return (
        <ValueContainer {...props}>
            <Placeholder {...props} isFocused={props.isFocused}>
                {props.selectProps.placeholder}
            </Placeholder>
            {React.Children.map(children, (child) => (child && child.type !== Placeholder ? child : null))}
        </ValueContainer>
    );
};

const SelectForm = ({ item, data, control, watch, options }) => {
    const getOptions = () => {
        const table = [];
        options.map((option) => table.push({ value: option.code, label: option.name_pl }));

        return table;
    };

    const defaultValue = data ? getDefaultValueInSelect(data[item.name]) : getDefaultValueInSelect('pl');

    return (
        <Controller
            as={Select}
            components={{ ValueContainer: CustomValueContainer }}
            options={getOptions()}
            control={control}
            name={item.name}
            rules={getFormRules({ items: item.rules, watch })}
            defaultValue={defaultValue}
            placeholder={item.label}
            classNamePrefix="select--inline"
            className="select--inline"
        />
    );
};

SelectForm.propTypes = {
    item: PropTypes.object,
    data: PropTypes.any,
    control: PropTypes.object,
    watch: PropTypes.func,
    handleBlur: PropTypes.func,
    handleFocus: PropTypes.func,
    trigger: PropTypes.func,
    options: PropTypes.array,
};

export default SelectForm;
